export function getScreenPosition(element, x = 0, y = 0) {
    if (!element) return { x, y }
    return getScreenPosition(element.offsetParent, x + element.offsetLeft, y + element.offsetTop)
}
